import { defineMessages } from 'react-intl';

export default defineMessages({
  // FAQs
  faqs: {
    id: 'src.pages.Dashboard.faqs',
    defaultMessage: 'FAQs',
  },
  faqsQuestion1: {
    id: 'src.pages.Dashboard.faqsQuestion1',
    defaultMessage: 'What information do I need to provide when reporting a claim?',
  },
  faqsQuestion2: {
    id: 'src.pages.Dashboard.faqsQuestion2',
    defaultMessage: 'How long will it take to settle my claim?',
  },
  faqsQuestion3: {
    id: 'src.pages.Dashboard.faqsQuestion3',
    defaultMessage: 'How will my claim affect my premium?',
  },
  faqsQuestion4: {
    id: 'src.pages.Dashboard.faqsQuestion4',
    defaultMessage: 'How do I submit my claim online?',
  },
  // FAQ1
  faqsQuestion1Content1: {
    id: 'src.pages.Dashboard.faqsQuestion1Content1',
    defaultMessage: 'At Sonnet, you can report your claim online or over the phone. We want you to get the help you need as quickly as possible. That’s why the more information you can give us up front, the better.',
  },
  faqsQuestion1Content2: {
    id: 'src.pages.Dashboard.faqsQuestion1Content2',
    defaultMessage: 'Before submitting your claim, make sure you’re familiar with the coverages you have on your policy. To view your policy, log into your account  and click "My Policies" on the dashboard, and then click on the policy you want to view. See if you have coverage for the specific loss or event and check if there are any exclusions that aren’t covered.',
  },
  faqsQuestion1Content3: {
    id: 'src.pages.Dashboard.faqsQuestion1Content3',
    defaultMessage: 'You should have the following information handy (if applicable) when you’re reporting your claim:',
  },
  faqsQuestion1Content4: {
    id: 'src.pages.Dashboard.faqsQuestion1Content4',
    defaultMessage: 'Your policy number (phone claims only – you won’t require this if you’re reporting your claim online)',
  },
  faqsQuestion1Content5: {
    id: 'src.pages.Dashboard.faqsQuestion1Content5',
    defaultMessage: 'Photos',
  },
  faqsQuestion1Content6: {
    id: 'src.pages.Dashboard.faqsQuestion1Content6',
    defaultMessage: 'Police reports',
  },
  faqsQuestion1Content7: {
    id: 'src.pages.Dashboard.faqsQuestion1Content7',
    defaultMessage: 'Correspondence relating to the claimed event',
  },
  faqsQuestion1Content8: {
    id: 'src.pages.Dashboard.faqsQuestion1Content8',
    defaultMessage: 'Names and contacts of any service providers you used to assist you',
  },
  faqsQuestion1Content9: {
    id: 'src.pages.Dashboard.faqsQuestion1Content9',
    defaultMessage: 'Invoices for any out-of-pocket expenses',
  },
  faqsQuestion1Content10: {
    id: 'src.pages.Dashboard.faqsQuestion1Content10',
    defaultMessage: 'Receipts for lost or damaged items',
  },
  faqsQuestion1Content11: {
    id: 'src.pages.Dashboard.faqsQuestion1Content11',
    defaultMessage: 'Contact information, namely phone numbers where you can be reached',
  },
  // FAQ2
  faqsQuestion2Content1: {
    id: 'src.pages.Dashboard.faqsQuestion2Content1',
    defaultMessage: 'You want your claim settled as quickly as possible – so do we! How long that takes depends on how severe or complex the loss is, whether or not you need a rental car or clean up service, and other steps that could be involved in your claim. Some claims can be wrapped up in a single phone call. Others might require us to bring in other claims experts.',
  },
  faqsQuestion2Content2: {
    id: 'src.pages.Dashboard.faqsQuestion2Content2',
    defaultMessage: 'You can speed things up by providing any necessary details or documents associated with the claim  as quickly as possible.',
  },
  faqsQuestion2Content3: {
    id: 'src.pages.Dashboard.faqsQuestion2Content3',
    defaultMessage: 'Did you know? Reporting your claim online can speed things up! ',
  },
  faqsQuestion2Content4: {
    id: 'src.pages.Dashboard.faqsQuestion2Content4',
    defaultMessage: 'Some things like booking a rental car or choosing a repair shop can be done directly during the online reporting process. This will save you time and get you back up and running more quickly! After you submit your online claim, a Claims team member will call you in approximately one business day to discuss your claim and proceed with the next steps.',
  },
  // FAQ3
  faqsQuestion3Content1: {
    id: 'src.pages.Dashboard.faqsQuestion3Content1',
    defaultMessage: 'It really depends on your specific situation, past claims history and other factors. One impact could be that you wouldn’t qualify for our claims-free discount. The true impact of your claim on your premium won’t actually be known until renewal time.',
  },
  faqsQuestion3Content2: {
    id: 'src.pages.Dashboard.faqsQuestion3Content2',
    defaultMessage: 'Even though your premium is tailored to you, your situation, your coverages and your past claims, it’s always good to be informed as to why your premium might go up at renewal. Learn more why your home insurance premium  or auto insurance premium  could increase.',
  },
  faqsQuestion3Content3: {
    id: 'src.pages.Dashboard.faqsQuestion3Content3',
    defaultMessage: 'If you do have questions about your renewal, contact us.  We can review your policy and go over the details with you.',
  },
  // FAQ4
  faqsQuestion4Content1: {
    id: 'src.pages.Dashboard.faqsQuestion4Content1',
    defaultMessage: 'Here’s how to report your claim online with Sonnet.',
  },
  faqsQuestion4Content2: {
    id: 'src.pages.Dashboard.faqsQuestion4Content2',
    defaultMessage: 'Heads up! ',
  },
  faqsQuestion4Content3: {
    id: 'src.pages.Dashboard.faqsQuestion4Content3',
    defaultMessage: 'Before you start to submit your claim, you’ll need to have certain information handy . This includes:',
  },
  faqsQuestion4Content4: {
    id: 'src.pages.Dashboard.faqsQuestion4Content4',
    defaultMessage: 'Details and notes from the incident',
  },
  faqsQuestion4Content5: {
    id: 'src.pages.Dashboard.faqsQuestion4Content5',
    defaultMessage: 'Documentation such as bills or receipts (for ambulance or fire truck costs, medical expenses, cleaning services, etc.)',
  },
  faqsQuestion4Content6: {
    id: 'src.pages.Dashboard.faqsQuestion4Content6',
    defaultMessage: 'Contact information for everyone involved',
  },
  faqsQuestion4Content7: {
    id: 'src.pages.Dashboard.faqsQuestion4Content7',
    defaultMessage: 'To submit a digital claim:',
  },
  faqsQuestion4Content8: {
    id: 'src.pages.Dashboard.faqsQuestion4Content8',
    defaultMessage: '1. Start your claim.',
  },
  faqsQuestion4Content9: {
    id: 'src.pages.Dashboard.faqsQuestion4Content9',
    defaultMessage: 'Click the "Start a digital claim" button.',
  },
  faqsQuestion4Content10: {
    id: 'src.pages.Dashboard.faqsQuestion4Content10',
    defaultMessage: '2.Tell us when it happened.',
  },
  faqsQuestion4Content11: {
    id: 'src.pages.Dashboard.faqsQuestion4Content11',
    defaultMessage: 'Enter the date and time the incident occurred, as accurately as possible. If you weren’t around at the time of the incident, you can enter the time it was discovered.',
  },
  faqsQuestion4Content12: {
    id: 'src.pages.Dashboard.faqsQuestion4Content12',
    defaultMessage: '3.Tell us what property or vehicle was impacted.',
  },
  faqsQuestion4Content13: {
    id: 'src.pages.Dashboard.faqsQuestion4Content13',
    defaultMessage: 'We’ll provide you with a list of vehicles and/or properties you have insured with us. Select the one that was impacted.',
  },
  faqsQuestion4Content14: {
    id: 'src.pages.Dashboard.faqsQuestion4Content14',
    defaultMessage: 'Note: ',
  },
  faqsQuestion4Content15: {
    id: 'src.pages.Dashboard.faqsQuestion4Content15',
    defaultMessage: 'There will also be options to select if you have injuries caused by a vehicle that was not yours (as a pedestrian or cyclist),  or if your property was damaged or lost in a location outside of your home.',
  },
  faqsQuestion4Content16: {
    id: 'src.pages.Dashboard.faqsQuestion4Content16',
    defaultMessage: '4.Enter your contact information.',
  },
  faqsQuestion4Content17: {
    id: 'src.pages.Dashboard.faqsQuestion4Content17',
    defaultMessage: 'You will then be asked to enter contact information so we can get in touch with you after you submit your claim. You’re also allowed to add another person as an additional contact to receive your claim details and help you if you need assistance.',
  },
  faqsQuestion4Content18: {
    id: 'src.pages.Dashboard.faqsQuestion4Content18',
    defaultMessage: 'Click ‘Continue’ to proceed.',
  },
  faqsQuestion4Content19: {
    id: 'src.pages.Dashboard.faqsQuestion4Content19',
    defaultMessage: '5.Tell us what happened.',
  },
  faqsQuestion4Content20: {
    id: 'src.pages.Dashboard.faqsQuestion4Content20',
    defaultMessage: 'Be as accurate as possible. Depending on the nature and complexity of your claim, we’ll ask about the people involved, any injuries to yourself or others, and the damages to your vehicle or home. This is also where you’ll upload any documents or photos you’d like to submit.  The process may take five to ten minutes.',
  },
  faqsQuestion4Content21: {
    id: 'src.pages.Dashboard.faqsQuestion4Content21',
    defaultMessage: 'Heads up!',
  },
  faqsQuestion4Content28: {
    id: 'src.pages.Dashboard.faqsQuestion4Content28',
    defaultMessage: 'If you’re reporting a property claim and need emergency repairs, you’ll select your emergency services vendor during this step.',
  },
  faqsQuestion4Content22: {
    id: 'src.pages.Dashboard.faqsQuestion4Content22',
    defaultMessage: '6.Review your claim.',
  },
  faqsQuestion4Content23: {
    id: 'src.pages.Dashboard.faqsQuestion4Content23',
    defaultMessage: 'Carefully review the information you entered. If you need to change anything, click “Edit” beside the section you wish to change.',
  },
  faqsQuestion4Content24: {
    id: 'src.pages.Dashboard.faqsQuestion4Content24',
    defaultMessage: '7.Select your service and/or Certified repair shop for your car (if applicable).',
  },
  faqsQuestion4Content25: {
    id: 'src.pages.Dashboard.faqsQuestion4Content25',
    defaultMessage: 'This is where you can select a certified repair shop  for your car from our list of quality vendors. If you’re eligible, you may also be asked to set up your rental car service or request an Uber Voucher.',
  },
  faqsQuestion4Content26: {
    id: 'src.pages.Dashboard.faqsQuestion4Content26',
    defaultMessage: '8.Submit your claim.',
  },
  faqsQuestion4Content27: {
    id: 'src.pages.Dashboard.faqsQuestion4Content27',
    defaultMessage: 'Whether it was through a live chat or directly via the online reporting form, after your claim is submitted it’s sent to a priority queue of digital Claims team members. An adjuster will review the details and call you within one business day. You can share additional details and pictures, or clarify any new information with this adjuster. They’ll also be able to answer any of your questions and tell you all you need to know about the next steps, what’s needed from you, and what Sonnet will do to handle your claim.',
  },
  faqsQuestion4Content29: {
    id: 'src.pages.Dashboard.faqsQuestion4Content29',
    defaultMessage: 'We know claims can be stressful - and we’re here for you. Remember, you can always chat with one of our dedicated Claims team members if you have any questions. To do so, make sure you log into your account first.',
  },
});
